export const makeFieldContainer = () => {
    return `display: flex;
          flex-direction: column;
          align-items: flex-start;`;
};
const makeVariation = ({ theme, variant, state }) => {
    return `border-color: ${theme.form.variant[variant][state].borderColor};
          background-color: ${theme.form.variant[variant][state].backgroundColor};
  
          input,
          textarea {
            color: ${theme.form.variant[variant][state].color};
          }

          .select__control {
            color: ${theme.form.variant[variant][state].color}!important;
      
            .select__placeholder{
              color: ${theme.form.variant[variant][state].placeHolderColor}!important;
            }
      
            & > i {
              &:before{
                background-color: ${theme.form.variant[variant][state].iconColor}!important;
              }
            }
          }

          .field-before,
          .field-after{
            i {
              &:before{
                background-color: ${theme.form.variant[variant][state].iconColor}!important;
              }
            }
          }

          .select__indicators{
            i {
              &:before{
                background-color: ${theme.form.variant[variant][state].iconColor}!important;
              }
            }
          }`;
};
export const makeField = ({ theme, variant = 'lighten', size = 'medium' }) => {
    return `position: relative;
          display: flex;
          width: 100%;
          align-items: center;
          transition: all 0.3s ease-in-out;
          padding-left: ${theme.form.size[size].padding};
          padding-right: ${theme.form.size[size].padding};
          transition: all 150ms ease-in-out;
          border: 1px solid;
          border-radius: 8px;
          ${makeVariation({ theme, variant, state: 'idle' })}

          &:disabled,
          &:hover,
          &:focus,
          &:active {
            outline: 0;
          }

          &.with-error {
            ${makeVariation({ theme, variant, state: 'error' })}
          }

          &.field-active {
            ${makeVariation({ theme, variant, state: 'active' })}
          }

          &.field-disabled{
            cursor: not-allowed;
            ${makeVariation({ theme, variant, state: 'disabled' })}
          }`;
};
const beforeAndAfter = `
  min-width: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;`;
export const makeFieldBefore = ({ theme, size = 'medium' }) => {
    return `
    ${beforeAndAfter}
    margin-right: ${theme.form.size[size].padding};`;
};
export const makeFieldAfter = ({ theme, size = 'medium' }) => {
    return `
    ${beforeAndAfter}
    margin-left: ${theme.form.size[size].padding};`;
};
export const makeLabel = ({ theme, size = 'medium' }) => {
    return `
  font-size: ${theme.form.size[size].fontSize};
  line-height: ${theme.form.size[size].lineHeight};
  color: ${theme.colors.black84};
  margin-bottom: 4px;`;
};
export const makeHelperLine = () => {
    return `
  width: 100%;
  min-height: 20px;
  line-height: 20px;`;
};
export const makeHelperText = () => {
    return `
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: rgba(0, 0, 24, 0.48);`;
};
export const makeCharacterCounter = ({ theme, errors }) => {
    return `
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  position: absolute;
  right: 10px;
  bottom: 0px;
  color: ${theme.colors.black84};
  user-select: none;`;
};
export const makeErrorMessage = ({ theme }) => {
    return `
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: ${theme.colors.danger.normal};`;
};
